import axios from "axios";
import { getSocket } from "./socketService";
import { toast } from "./SnackBarUtils";

const tokenKey = () =>
  `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`;

const clearStorage = () => {
  localStorage.removeItem(tokenKey());
  localStorage.removeItem(
    `${process.env.REACT_APP_COGNITO_CLIENT_ID}.signedIn`
  );
  return;
};

export const storeRotatedToken = (response) => {
  const newToken = response?.headers?.["x-access-token"];
  if (!newToken) return;

  try {
    localStorage.setItem(tokenKey(), newToken);
  } catch (e) {
    console.error("Unable to store rotated token");
  }
};

const signOut = () => {
  clearStorage();
  const socket = getSocket();
  if (socket) {
    socket.disconnect();
  }
  window.location.href = "/";
  return { success: false };
};

const handleError = (e, description) => {
  storeRotatedToken(e?.response);

  if (e?.response?.status === 401) {
    console.error("Not authorized. Signing out");
    return signOut();
  }

  if (!e?.response) {
    console.error(`Network error ${description}: ${e?.message}`);
    toast.error("Connection problem. Please check your network and try again.");
    return { success: false, networkError: true };
  }

  console.error(`Error ${description}: ${e.message}`);
  return e.response?.data;
};

const request = async (req, method = null, body = null) => {
  let token;
  try {
    token = localStorage.getItem(tokenKey());
    if (!token) {
      console.error("No available token");
      return signOut();
    }
  } catch (e) {
    console.error("Error setting token.");
    return;
  }

  const headers = {
    Accesstoken: token,
  };

  if (!method) {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_TNFT_SERVER}/${req}`,
        { headers: headers }
      );
      storeRotatedToken(result);
      return result.data;
    } catch (e) {
      return handleError(e, `getting ${req}`);
    }
  } else if (method === "post") {
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_TNFT_SERVER}/${req}`,
        body,
        { headers: headers }
      );
      storeRotatedToken(result);
      return result.data;
    } catch (e) {
      return handleError(e, `posting ${req}`);
    }
  }
};
export default request;
